"use strict";
/*jshint esversion: 11 */

import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import PropTypes from "prop-types";
import CsfMembrePageHeading
  from "../csf-membre-page-heading/csf-membre-page-heading";
import CsfMembreSideMenu from "../csf-membre-side-menu/csf-membre-side-menu";
import {
  startLoadingSpinner,
  stopLoadingSpinner
} from "../../csf-ufc-pivotal/includes/utils";
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import CsfMembreNotificationsDataLayer from "./CsfMembreNotificationsDataLayer";
import CsfMembreNotificationsTable from "./CsfMembreNotificationsTable";

export function CsfMembreNotifications({apiUrl, apiEnv, urlDossierUfc, urlNotifications}) {
  const [isError, setIsError] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [memberInfo, setMemberInfo] = useState({});
  const [notificationsList, setNotificationsList] = useState([]);
  const [ufcFileId, setUfcFileId] = useState('');
  const [checkedPrintOption, setCheckedPrintOption] = useState('');
  const [dataLayer, setDataLayer] = useState({});

  /*
  * Call this method when an api error occurs.
  * */
  function apiErrorCallback(errorMessage) {
    setIsError(true);
    stopLoadingSpinner();
  }

  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
  }, []);

  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest()
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          console.error('Error while fetching token');
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  function notificationIsRead(id) {
    if (ufcFileId) {
      const formData = {
        Notification__Secondary: [{
          CSF_EM_Notification_Id: id,
          Is_Read: true
        }]
      };

      dataLayer.submitNotifications(ufcFileId, formData, null);
    }
  }

  useEffect(() => {
    if (accessToken) {
      const dataObj = new CsfMembreNotificationsDataLayer(apiUrl, apiEnv, accessToken, apiErrorCallback);
      dataObj.fetchMemberInfo(setMemberInfo);
      setDataLayer(dataObj);
    }
  }, [accessToken]);

  useEffect(() => {
    if (accessToken && dataLayer?.isInit && memberInfo?.Contact_Id) {
      dataLayer.fetchContactInfo(memberInfo.Contact_Id, setUfcFileId, setNotificationsList);
    }
  }, [memberInfo, dataLayer]);


  return (
    <main className="membre home">

      <div className="content">
        {/* main section */}
        <section className="list primary primary-bg non-print-wrapper">

          {/* sub title */}

          <CsfMembrePageHeading
            title={window.Drupal.t('membre.notification.title')}
            memberName={memberInfo["Prénom"] + ' ' + memberInfo["Nom"]}
            certificatNumber={memberInfo["No_Dossier"]}
          />

          {isError && (
            <div className="alert alert-danger mb-4" role="alert"
                 aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
          )}

          <div className="notifications__body">

            <CsfMembreNotificationsTable notificationsList={notificationsList} notificationIsRead={notificationIsRead}
                                         apiUrl={apiUrl}
                                         apiEnv={apiEnv}
                                         accessToken={accessToken}
            />

          </div>

        </section>

        {/* aside section */}
        <CsfMembreSideMenu
          apiUrl={apiUrl}
          apiEnv={apiEnv}
          urlDossierUfc={urlDossierUfc}
          urlNotifications={urlNotifications}
          checkedPrintOption={checkedPrintOption}
          setCheckedPrintOption={setCheckedPrintOption}
        />

      </div>
    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfMembreNotifications');


  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlDossierUfc = domNode.getAttribute("data-urlSectionMembreDossierUfc");
    const urlNotifications = domNode.getAttribute("data-urlSectionMembreNotifications");

    root.render(<CsfMembreNotifications
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlDossierUfc={urlDossierUfc}
      urlNotifications={urlNotifications}
    />);
  }
});

CsfMembreNotifications.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlDossierUfc: PropTypes.string,
  urlNotifications: PropTypes.string,
};
